import { useQuery } from 'urql';
import { GetMagazinContentDocument } from '@packages/gql/generated/shopping/GetMagazinContentDocument';
import { useMemo } from 'react';
import { logger } from '@packages/shared/src/utils/logger/logger';
import type { SortBy } from '../../../interfaces/components';

/* GraphQL */ `
  query GetMagazinContent($tags: [String!]!, $limit: Int, $sortBy: SortBy) {
    getMagazinContentMultipleTags(tags: $tags, limit: $limit, sortBy: $sortBy) {
      id
      description
      headline
      taxonomy_terms
      path
      teaser_image {
        id
        url
        alt
        title
        width
        height
      }
    }
  }
`;

export const useRelatedContentGql = (tags: string[], limit?: number, sortBy?: SortBy) => {
  const [{ data, error, fetching }] = useQuery({
    query: GetMagazinContentDocument,
    variables: { tags, limit, sortBy },
    context: useMemo(() => ({ suspense: false }), []),
  });
  if (error) {
    logger.error({ err: error }, 'Error fetching related content');
    return { error };
  }
  return { fetching, relatedContentData: data?.getMagazinContentMultipleTags || [] };
};
